import React, { FC } from 'react';

export interface LoadingAnimationProps {
    children: React.ReactNode | React.ReactNode[]
}

/**
 * LoadingAnimation
 *
 * displays a loading animation
 *
 * @constructor
 */
const LoadingAnimation: FC< LoadingAnimationProps > =  ({ children }) => {



    return (

        <>
            <div className='loader-background'>
                { children }
            </div>
            <div className='loader' />

        </>
    );
};

export default LoadingAnimation;